/**
 * `/mail/signup` smart redirect (OCP-174).
 *
 * Public route — landing target for marketing CTAs like "Sign up for
 * orboto Mail" on the orboto.io site. Resolves to one of two places
 * based on the auth state:
 *
 *   - authenticated   → /mail (their dashboard)
 *   - unauthenticated → /signup?from=/mail (then back to /mail after)
 *
 * Without this redirect every visitor (logged in or not) hit
 * /mail → ProtectedRoute → /login because /mail/signup wasn't a
 * known route and ProtectedRoute can't tell the difference between
 * "you need an account" and "you ARE an account, just go to /mail".
 *
 * Rendered loading-state mirrors ProtectedRoute (same spinner) so the
 * visual transition from marketing → portal feels seamless.
 */
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router-dom';

import { useAuth } from '../lib/auth-context';

export function MailSignupRedirect() {
  const { status } = useAuth();
  const { t } = useTranslation('mail-layout');

  if (status === 'loading') {
    return (
      <div className="flex min-h-dvh items-center justify-center bg-gray-50 dark:bg-gray-800">
        <div className="text-sm text-gray-500">{t('loading')}</div>
      </div>
    );
  }
  if (status === 'authenticated') {
    return <Navigate to="/mail" replace />;
  }
  return <Navigate to="/signup?from=/mail" replace />;
}
